import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-change-needed',
  templateUrl: './change-needed.component.html',
  styleUrls: ['./change-needed.component.scss'],
})
export class ChangeNeededComponent implements OnInit {

  changeNeededForm!: FormGroup;

  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserName: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  getListOfBandNameOfComp: any = [];
  getListOfGradeNameOfComp: any = [];
  getListOfDesignationsOfComp: any = [];
  userId: any;
  tabName: any;
  storedData: any;


  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<ChangeNeededComponent>,
    @Inject(MAT_DIALOG_DATA) public employeedata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog,) {

    console.log(employeedata);
    this.tabName = employeedata.tabName;
    this.userId = employeedata.userID;
    this.changeNeededForm = this.fb.group({
      oldctc: ['', Validators.required],
      newctc: ['', Validators.required],

      oldGrade: ['', Validators.required],
      oldBand: ['', Validators.required],
      oldDesignation: ['', Validators.required],
      newgrade: ['', Validators.required],
      newBand: ['', Validators.required],
      newDesignation: ['', Validators.required],
      firstName: [''],
      officialEmail: ['']

    });
    // Patch data into the form



  }

  ngOnInit() {


    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getBandsByCompany();
    this.getGradeByCompany();
    this.getDesignationsByCompany();
    this.getUserOldData();
    this.getUserByID();
    if (this.tabName === 'ReportTab') {
      this.changeNeededForm.controls['newDesignation'].disable();
      this.changeNeededForm.controls['newctc'].disable();
      this.changeNeededForm.controls['newgrade'].disable();
      this.changeNeededForm.controls['newBand'].disable();
    } else {
      this.changeNeededForm.controls['newDesignation'].enable();
      this.changeNeededForm.controls['newctc'].enable();
      this.changeNeededForm.controls['newgrade'].enable();
      this.changeNeededForm.controls['newBand'].enable();
    }

    this.storedData= JSON.parse(sessionStorage.getItem('ProbassionChangedData') || '{}');






  }

  hasError(controlName: string, errorType: string) {
    if (this.isClosing) return false; // Do not show errors when closing
    const control = this.changeNeededForm.get(controlName);
    return control?.hasError(errorType) && (control.dirty || control.touched);
  }

  isClosing = false; // Flag to track when dialog is closing

  closeDialog() {
    this.isClosing = true; // Set flag to true when closing
    this.dialogRef.close();
  }



  getBandsByCompany() {
    this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfBandNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfBandNameOfComp.push(obj);
      });
      this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  getGradeByCompany() {
    this.httpService.callGetService(this.config.getGradesByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGradeNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGradeNameOfComp.push(obj);
      });
      this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsByCompany() {
    this.httpService.callGetService(this.config.getDesignationsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsOfComp.push(obj);
      });
      this.getListOfDesignationsOfComp = this.getListOfDesignationsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  oldData: any = [];
  getUserOldData() {
    this.httpService.callGetService(this.config.getUserOldDetails + this.loggedInUserCompanyID).subscribe((data: any) => {
      console.log(data.data);
      this.oldData = data.data.filter((elm: any) => elm.userId == this.userId);
    })
  }


  getUserByID() {
    this.httpService.callGetService(this.config.getUserByIDForProbation + this.userId).subscribe((data: any) => {
      console.log(data.data);
      if (data?.data) {
        this.getUserOldData();
        this.patchAssetForm(data.data)
      }
    })
  }

  // Method to patch the data into the form
  patchAssetForm(data: any): void {
    console.log(this.oldData);

    if (this.tabName == 'ReportTab') {
      this.changeNeededForm.patchValue({
        oldctc: this.oldData[0]?.oldAnnualTotalCtc,
        oldDesignation: this.oldData[0]?.oldDesignation,
        oldGrade: this.oldData[0]?.oldGrade,
        oldBand: this.oldData[0]?.oldBand,
        newctc: data.annualTotalCtc,
        newgrade: data.grade,
        newBand: data.band,
        newDesignation: data.designation,
      });
    } else if (this.storedData) {
      this.changeNeededForm.patchValue({
        oldctc: data.annualTotalCtc,
        oldDesignation: data.designation,
        oldGrade: data.grade,
        oldBand: data.band,
        newctc:this.storedData.userID==this.userId? this.storedData.annualTotalCtc:null,
        newgrade:this.storedData.userID==this.userId?  this.storedData.grade:null,
        newBand: this.storedData.userID==this.userId? this.storedData.band:null,
        newDesignation: this.storedData.userID==this.userId? this.storedData.designation:null,
      })
    }
    else {

      this.changeNeededForm.patchValue({
        oldctc: data.annualTotalCtc,
        oldDesignation: data.designation,
        oldGrade: data.grade,
        oldBand: data.band,
        firstName: data.firstName,
        officialEmail: data.officialEmail
      });
    }
    console.log(this.changeNeededForm.value);

  }
  addSubmitForm: boolean = false
  saveChanges() {
    // let fromData = JSON.parse(sessionStorage.getItem('ProbassionChangedData') || '[]'); // Retrieve existing data or initialize an empty array
    const newData = {
      "annualTotalCtc": this.changeNeededForm.value.newctc,
      "grade": this.changeNeededForm.value.newgrade,
      "band": this.changeNeededForm.value.newBand,
      "designation": this.changeNeededForm.value.newDesignation,
      "userID":this.userId
    };

    // fromData.push(newData);

    // sessionStorage.setItem('ProbassionChangedData', JSON.stringify(fromData));
    if (this.changeNeededForm.invalid) {

      this.addSubmitForm = true;
      this.changeNeededForm.markAllAsTouched();
    }
    if (this.changeNeededForm.valid) {

      // this.httpService.callPutService(`${this.config.changedProbation}/${this.userId}`, fromData).subscribe((data: any) => {}

      sessionStorage.setItem('ProbassionChangedData', JSON.stringify(newData));


      // Success popup
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Data save successfully',
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });

      // Handle the result of the dialog
      dialogRef.afterClosed().subscribe(() => {
        this.dialogRef.close();
      });

    }

    (error: any) => {

      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: error.error.error || 'An error occurred while processing your request. Please try again.',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: true
        }
      });

      errorDialogRef.afterClosed().subscribe(() => {
        // Optionally handle any action after closing the error dialog
        console.log('Error dialog closed');
      });
    }

    // )
  }
}

